module.exports = __webpack_public_path__ + "img/l7.7276ee50.png";